const options = document.querySelectorAll('.quizz-content .question .options li');
const result = document.querySelector('.result-content');
let collections = new Set();
let remove = new Set();



function popuplateCollection() {
    const filteredArray = Array.from(collections).filter(item => !remove.has(item));
    const ids = new Set(filteredArray);
  
    for(id of ids) {
        const collectionElement = document.querySelector('.result-content .result .grid__item[data-collection-id="' + id + '"]');
        if (collectionElement) {
            collectionElement.classList.add('selected');
        }
    }

    if (ids.size < 3) {
      result.querySelector('.result').style.justifyContent = 'center';
    }
}


options.forEach(li => {
    li.addEventListener('click', () => {
        /* save collections */
        if(li.dataset.collections) {
            const pickedCollections = li.dataset.collections.split(',');
            pickedCollections.forEach(v => collections.add(v.trim()));
            const removeCollection = li.dataset.remove.split(',');
            removeCollection.forEach(v => remove.add(v.trim()));
        }

        /* hide current question */
        const current = li.closest('.question');
        current.classList.remove('active');

        /* show the next question */
        const next = current.nextElementSibling;
        if (next && next.classList.contains('question')) {
            next.classList.add('active');
        } else {
            /* if last question, show the result */
            popuplateCollection();
            result.classList.add('active')
        }
    });
});